import Swiper from "swiper/bundle";

const lightbox = {
  el: null,

  loading: false,

  slider: null,
  slider_dom: null,

  init: function () {
    if ($(".gallery-slider").length) {
      lightbox.el = $("#lightbox");
      lightbox.slider_dom = lightbox.el.find(".lightbox-slider");
      // Make slider in content
      lightbox.gallery();
      // Add events
      lightbox.events();
    }
  },

  gallery: function () {
    $(".gallery--product").each(function (index) {
      var galleryEl = $(this);

      var navPrev = galleryEl.find(".gallery-thumbs-wrap .swiper-button-prev")[0];
      var navNext = galleryEl.find(".gallery-thumbs-wrap .swiper-button-next")[0];
      var paginationEl = galleryEl.find(".gallery-slider-wrap .swiper-pagination")[0];

      var thumbsSwiper = new Swiper(galleryEl.find(".gallery-thumbs")[0], {
        loop: true,
        slidesPerView: 3,
        centeredSlides: true,
        watchSlidesVisibility: true,
        slideToClickedSlide: true,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 3,
        },
        navigation: {
          prevEl: navPrev,
          nextEl: navNext,
        },
        spaceBetween: 10,
        touchRatio: 0.4,
        loopAdditionalSlides: 1,
      });

      var gallerySwiper = new Swiper(galleryEl.find(".gallery-slider")[0], {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: paginationEl,
          type: "bullets",
        },
        breakpoints: {
          600: {
            pagination: false,
          }
        },
        on: {
          init: function () {
            galleryEl
              .children(".gallery-slider")
              .addClass("gallery-slider--loaded");
          },
        },
        loopAdditionalSlides: 3,
      });

      thumbsSwiper.controller.control = gallerySwiper;
      gallerySwiper.controller.control = thumbsSwiper;
    });

    $(".gallery.gallery-slider").each(function (index) {
      var gallery_dom = $(this);

      // Init content slider
      var nav_prev = gallery_dom.find(".swiper-button-prev")[0];
      var nav_next = gallery_dom.find(".swiper-button-next")[0];
      var slider = new Swiper(gallery_dom[0], {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        },
        navigation: {
          prevEl: nav_prev,
          nextEl: nav_next,
        },

        on: {
          init: function () {
            gallery_dom
              .find(".gallery-wrapper")
              .addClass("gallery-wrapper--loaded");
          },
        },
      });
    });
  },

  events: function () {
    // Close on X click
    $("body").on("click", ".lightbox-close", function (e) {
      e.preventDefault();
      lightbox.close();
    });

    // Close on ESC key
    $(document).keyup(function (e) {
      if (e.keyCode === 27) {
        lightbox.close();
      }
    });

    // Close if clicked outside of image
    $("body").on("click", ".lightbox-body", function (e) {
      var container = lightbox.el.find(".lightbox-container");
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        lightbox.close();
      }
    });

    // Expand image on click
    $("body").on("click", ".gallery img", function () {
      var gallery_dom = $(this).closest(".gallery");
      lightbox.open(gallery_dom);
    });

    // Expand image on Expand click
    $("body").on("click", ".gallery-slider__expand", function (e) {
      e.preventDefault();
      var slider = $(this).closest(".gallery");
      lightbox.open(slider);
    });
  },

  close: function () {
    // Destroy slider
    // if (lightbox.slider) {
    //   lightbox.slider.destroy();
    // }
    // Remove lightbox
    lightbox.el.removeClass("lightbox--open");
    // Allow scroll
    $("html").removeClass("no-scroll");
  },

  open: function (slider) {
    if (!lightbox.loading) {
      lightbox.loading = true;

      // Disable scroll
      $("html").addClass("no-scroll");
      lightbox.el.addClass("lightbox--loading");

      // Adds slides to slider
      var images = slider.attr("data-ids").split(",").map(Number);
      $.ajax({
        url: ajaxurl,
        data: {
          action: "lightbox_load_images",
          images: images,
        },
        type: "POST",
        success: function (response) {
          if (response.success) {
            lightbox.el.find(".lightbox-wrapper").html(response.data);
            // Load swiper on lightbox
            lightbox.construct(slider);
          }
        },
      });
    }
  },

  construct: function (slider) {
    // Init slider
    var slide_num = 0;
    if (slider[0].swiper) {
      slide_num = slider[0].swiper.realIndex;
    }

    var nav_prev = lightbox.el.find(".swiper-button-prev")[0];
    var nav_next = lightbox.el.find(".swiper-button-next")[0];

    lightbox.slider = new Swiper(lightbox.slider_dom[0], {
      initialSlide: slide_num,
      loop: true,
      zoom: {
        maxRatio: 3,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      keyboard: {
        enabled: true,
      },
      navigation: {
        prevEl: nav_prev,
        nextEl: nav_next,
      },
    });

    // Open lightbox
    lightbox.el.removeClass("lightbox--loading");
    lightbox.el.addClass("lightbox--open");
    lightbox.loading = false;

    if (slider[0].swiper) {
      lightbox.slider.on("slideChange", function () {
        // Sync with content
        var slide_to = this.realIndex;
        slider[0].swiper.slideToLoop(slide_to);
      });
    }
  },
};

export default lightbox;
